import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcTextGradientComponent } from '../../shared/ddc/ddc-text-gradient/ddc-text-gradient.component'

@Component({
  selector: 'ddc-pricing-plan',
  templateUrl: './ddc-pricing-plan.component.html',
  styleUrls: ['./ddc-pricing-plan.component.scss'],
  imports: [DdcTextGradientComponent, MatIconModule, CommonModule, AngularMaterialsModules],
})
export class DdcPricingPlanComponent {
  @Input() plan: 'free' | 'plus' | 'pro' = 'free'
  @Input() infoOnly: boolean = false
  @Input() toBillingPage?: (type: string) => void
}
